module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child2-aebefae73f3ac8d9c4ce3e230f887662.svg";